import { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";

const WA_LINK = "https://api.whatsapp.com/send?phone=96892102051&text=Hello%20Blue%20Moon%20Beauty%20Salon%20%26%20Spa%2C%20I%20would%20like%20more%20information%20about%20your%20services.";

const footerLinks: Record<string, { en: string; ar: string; titleHref: string; links: { en: string; ar: string; href: string }[] }> = {
  "Our Services": {
    en: "Our Services",
    ar: "خدماتنا",
    titleHref: "/services",
    links: [
      { en: "Hair Styling", ar: "تصفيف الشعر", href: "/services#hair" },
      { en: "Facials & Skincare", ar: "جلسات الوجه والعناية بالبشرة", href: "/services#facials" },
      { en: "Nail Services", ar: "العناية بالأظافر", href: "/services#nails" },
      { en: "Waxing & Threading", ar: "إزالة الشعر", href: "/services#waxing" },
      { en: "Massage & Body", ar: "المساج والعناية بالجسم", href: "/services#massage" },
      { en: "Makeup Services", ar: "خدمات المكياج", href: "/services#makeup" },
    ],
  },
  "Find Us": {
    en: "Find Us",
    ar: "موقعنا",
    titleHref: "/#contact",
    links: [
      { en: "Al Koudh 7, Mazoon Street", ar: "الخوض 7، شارع مزون", href: "https://maps.google.com/?q=Al+Koudh+7+Mazoon+Street+Muscat+Oman" },
      { en: "Muscat, Oman", ar: "مسقط، سلطنة عمان", href: "https://maps.google.com/?q=Al+Koudh+7+Mazoon+Street+Muscat+Oman" },
      { en: "+968 921 02051", ar: "اتصل بنا", href: "tel:+96892102051" },
      { en: "moonb1741@gmail.com", ar: "البريد الإلكتروني", href: "mailto:moonb1741@gmail.com" },
      { en: "www.bluemoonoman.com", ar: "موقعنا الإلكتروني", href: "https://www.bluemoonoman.com" },
      { en: "Sat–Thu: 9am–9pm", ar: "السبت–الخميس: 9ص–9م", href: "#" },
      { en: "Friday: 2pm–9pm", ar: "الجمعة: 2م–9م", href: "#" },
    ],
  },
  "Quick Links": {
    en: "Quick Links",
    ar: "روابط سريعة",
    titleHref: "/",
    links: [
      { en: "Home", ar: "الرئيسية", href: "/" },
      { en: "About Us", ar: "عن الصالون", href: "/#about" },
      { en: "Our Team", ar: "فريقنا", href: "/#team" },
      { en: "Gallery", ar: "معرضنا", href: "/#gallery" },
      { en: "Contact Us", ar: "اتصل بنا", href: "/#contact" },
      { en: "Book Now", ar: "احجزي الآن", href: WA_LINK },
    ],
  },
};

const socials = [
  { icon: "ri-instagram-line", href: "https://instagram.com/bluemoonbeautyoman", label: "Instagram" },
  { icon: "ri-facebook-fill", href: "#", label: "Facebook" },
  { icon: "ri-tiktok-line", href: "#", label: "TikTok" },
  { icon: "ri-whatsapp-line", href: WA_LINK, label: "WhatsApp" },
];

export default function Footer() {
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState<"idle" | "success" | "error">("idle");
  const navigate = useNavigate();
  const location = useLocation();

  const handleNavClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    if (href === "/" || href.startsWith("/#")) {
      e.preventDefault();
      if (href === "/") {
        navigate("/");
        window.scrollTo({ top: 0, behavior: "smooth" });
        return;
      }
      const id = href.replace("/#", "");
      if (location.pathname === "/") {
        const el = document.getElementById(id);
        if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
      } else {
        navigate("/#" + id);
      }
      return;
    }
    if (!href.startsWith("http") && !href.startsWith("tel:") && !href.startsWith("mailto:") && href !== "#") {
      e.preventDefault();
      navigate(href);
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  };

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (!email.trim()) return;
    try {
      const formData = new URLSearchParams();
      formData.append("email", email);
      const res = await fetch("https://readdy.ai/api/form/d71h3ighb0rqicn68hjg", {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: formData.toString(),
      });
      if (res.ok) {
        setStatus("success");
        setEmail("");
      } else {
        setStatus("error");
      }
    } catch {
      setStatus("error");
    }
  };

  return (
    <footer id="contact" className="bg-[#f4f2ec]">
      {/* Top CTA */}
      <div className="bg-[#1a2744] py-14 sm:py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 text-center">
          <div className="w-10 h-10 flex items-center justify-center mx-auto mb-4 border border-[#c6a864]/40">
            <i className="ri-moon-line text-[#c6a864] text-xl"></i>
          </div>
          <p className="text-white/60 text-xs tracking-[0.4em] uppercase mb-3 font-light">
            Ready to Glow? / مستعدة للتألق؟
          </p>
          <h2
            className="text-white text-3xl sm:text-4xl font-light tracking-wide mb-3"
            style={{ fontFamily: "'Playfair Display', serif" }}
          >
            Book Your Experience
          </h2>
          <p
            className="text-white/60 text-lg mb-8"
            style={{ fontFamily: "'Noto Naskh Arabic', serif" }}
          >
            احجزي تجربتك الجمالية مع صالون القمر الأزرق
          </p>
          <div className="flex justify-center">
            <a
              href={WA_LINK}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 whitespace-nowrap cursor-pointer bg-[#25D366] text-white text-xs tracking-[0.2em] uppercase px-10 py-4 hover:bg-[#20ba5a] transition-colors duration-300"
            >
              <i className="ri-whatsapp-line text-base"></i>
              Book via WhatsApp — احجزي الآن
            </a>
          </div>
        </div>
      </div>

      {/* Newsletter */}
      <div className="border-b border-[#e5e0d5] py-10 sm:py-12 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 flex flex-col lg:flex-row items-center justify-between gap-6">
          <div>
            <p
              className="text-[#1a2744] text-lg sm:text-xl font-light"
              style={{ fontFamily: "'Playfair Display', serif" }}
            >
              Stay Updated with Blue Moon
            </p>
            <p className="text-gray-500 text-sm mt-1 tracking-wide">
              Get exclusive offers, beauty tips &amp; news from Muscat&apos;s top salon
            </p>
            <p className="text-gray-400 text-xs mt-0.5" style={{ fontFamily: "'Noto Naskh Arabic', serif", direction: "rtl" }}>
              عروض حصرية ونصائح جمالية من صالون القمر الأزرق
            </p>
          </div>
          <form
            data-readdy-form
            onSubmit={handleSubmit}
            className="flex gap-0 w-full max-w-md"
          >
            <input
              type="email"
              name="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Your email address / بريدك الإلكتروني"
              className="flex-1 bg-white border border-[#e5e0d5] px-4 py-3 text-sm text-[#1a2744] placeholder-gray-400 outline-none focus:border-[#c6a864] transition-colors"
              required
            />
            <button
              type="submit"
              className="whitespace-nowrap cursor-pointer bg-[#c6a864] text-white text-xs tracking-widest uppercase px-5 py-3 hover:bg-[#b8965a] transition-colors duration-300"
            >
              Subscribe
            </button>
          </form>
        </div>
        {status === "success" && (
          <p className="text-center text-[#c6a864] text-sm tracking-wide mt-4">Thank you for subscribing! شكراً للاشتراك!</p>
        )}
        {status === "error" && (
          <p className="text-center text-red-400 text-sm tracking-wide mt-4">Something went wrong. Please try again.</p>
        )}
      </div>

      {/* Main footer */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-12 sm:py-16">
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-8 sm:gap-10">
          {/* Brand */}
          <div className="col-span-2 sm:col-span-1">
            <div className="mb-4">
              <a href="/" onClick={(e) => handleNavClick(e, "/")} className="cursor-pointer">
                <p
                  className="text-[#1a2744] text-xl font-semibold tracking-[0.2em] uppercase hover:text-[#c6a864] transition-colors"
                  style={{ fontFamily: "'Playfair Display', serif" }}
                >
                  BLUE MOON
                </p>
              </a>
              <p
                className="text-[#c6a864] text-lg font-bold mt-1"
                style={{ fontFamily: "'Noto Naskh Arabic', serif" }}
              >
                صالون وسبا القمر الأزرق
              </p>
              <p className="text-gray-400 text-xs tracking-wide mt-0.5">Beauty Salon &amp; Spa — مسقط، عمان</p>
            </div>
            <p className="text-gray-500 text-sm leading-relaxed mb-1">
              Muscat&apos;s premier beauty destination at Al Koudh 7, Mazoon Street, Oman.
            </p>
            <p className="text-gray-400 text-sm leading-relaxed mb-5 text-right" style={{ fontFamily: "'Noto Naskh Arabic', serif" }}>
              وجهتك الأولى للجمال في مسقط، الخوض 7، شارع مزون، سلطنة عمان.
            </p>
            <div className="flex gap-3">
              {socials.map((s) => (
                <a
                  key={s.icon}
                  href={s.href}
                  target="_blank"
                  rel="nofollow noopener noreferrer"
                  aria-label={s.label}
                  className="w-8 h-8 flex items-center justify-center border border-[#e5e0d5] text-gray-500 hover:border-[#c6a864] hover:text-[#c6a864] transition-colors duration-300 cursor-pointer"
                >
                  <i className={`${s.icon} text-sm`}></i>
                </a>
              ))}
            </div>
          </div>

          {/* Link columns */}
          {Object.values(footerLinks).map((section) => (
            <div key={section.en}>
              <h4 className="text-[#1a2744] text-xs tracking-[0.2em] uppercase font-medium mb-1">
                <a
                  href={section.titleHref}
                  onClick={(e) => handleNavClick(e, section.titleHref)}
                  className="hover:text-[#c6a864] transition-colors cursor-pointer"
                >
                  {section.en}
                </a>
              </h4>
              <p className="text-[#c6a864] text-sm font-semibold mb-4" style={{ fontFamily: "'Noto Naskh Arabic', serif" }}>
                {section.ar}
              </p>
              <ul className="space-y-2.5">
                {section.links.map((link) => (
                  <li key={link.en}>
                    <a
                      href={link.href}
                      onClick={(e) => handleNavClick(e, link.href)}
                      target={link.href.startsWith("http") ? "_blank" : undefined}
                      rel={link.href.startsWith("http") ? "noopener noreferrer" : undefined}
                      className="group flex flex-col cursor-pointer"
                    >
                      <span className="text-gray-500 text-xs hover:text-[#c6a864] transition-colors duration-200 leading-relaxed">{link.en}</span>
                      <span className="text-gray-400 text-xs hover:text-[#c6a864] transition-colors duration-200" style={{ fontFamily: "'Noto Naskh Arabic', serif" }}>{link.ar}</span>
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>

      {/* Map hint */}
      <div className="border-t border-[#e5e0d5] bg-white py-5">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-3 flex-wrap">
            <a
              href="https://maps.google.com/?q=Al+Koudh+7+Mazoon+Street+Muscat+Oman"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-2 text-gray-400 text-xs hover:text-[#c6a864] transition-colors cursor-pointer"
            >
              <i className="ri-map-pin-line text-[#4a7fa5]"></i>
              <span>Al Koudh 7, Mazoon Street, Muscat, Oman</span>
            </a>
            <div className="flex items-center gap-4 flex-wrap justify-center">
              <a
                href="tel:+96892102051"
                className="flex items-center gap-1.5 text-gray-400 text-xs hover:text-[#c6a864] transition-colors cursor-pointer"
              >
                <i className="ri-phone-line text-[#c6a864]"></i>
                <span>+968 921 02051</span>
              </a>
              <a
                href="mailto:moonb1741@gmail.com"
                className="flex items-center gap-1.5 text-gray-400 text-xs hover:text-[#c6a864] transition-colors cursor-pointer"
              >
                <i className="ri-mail-line text-[#c6a864]"></i>
                <span>moonb1741@gmail.com</span>
              </a>
              <a
                href="https://www.bluemoonoman.com"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-1.5 text-gray-400 text-xs hover:text-[#c6a864] transition-colors cursor-pointer"
              >
                <i className="ri-global-line text-[#c6a864]"></i>
                <span>bluemoonoman.com</span>
              </a>
              <a
                href={WA_LINK}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-2 text-[#25D366] text-xs hover:text-[#20ba5a] transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="ri-whatsapp-line text-base"></i>
                WhatsApp Us
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="border-t border-[#e5e0d5] py-5">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-gray-400 text-xs tracking-wide">
            &copy; {new Date().getFullYear()} Blue Moon Beauty Salon &amp; Spa. Al Koudh, Muscat, Oman. All rights reserved.
          </p>
          <div className="flex gap-4 sm:gap-6">
            {["Privacy Policy", "Terms of Service"].map((t) => (
              <a
                key={t}
                href="#"
                className="text-gray-400 text-xs hover:text-[#c6a864] transition-colors cursor-pointer"
              >
                {t}
              </a>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
}
